import supabase from "../supabaseClient";

/**
 * Invoke the notify-stats edge function without exposing service keys.
 */
export const notifyStats = async ({ email, name, type = "stats", gameDetails = null }) => {
  if (!email || !name) {
    console.warn("notifyStats called without required email/name");
    return;
  }

  const { data, error } = await supabase.functions.invoke("notify-stats", {
    body: {
      email,
      name,
      type,
      ...(gameDetails ? { gameDetails } : {}),
    },
  });

  if (error) {
    throw error;
  }

  return data;
};


